export const DateFormat = {
    ApiFormat: "YYYY-MM-DD",
};